import React, { useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link,useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import MediaModel from "../../MediaUpload/MediaModel";
import toast from "react-hot-toast";

// ---------- SLUG GENERATOR ----------


const AddBlog = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  const imageInputRef = useRef(null);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [imageModel, setImageModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // ReactQuill content
  const [shortContent, setShortContent] = useState("");

  const handleShortContentChange = (content) => {
    setShortContent(content);
  };

  const toggleImageModal = () => {
    setImageModel(!imageModel);
    setSelectedImage([]);
  };

  const handleUploadImage = (image) => {
    if (image) {
      setUploadedImages([image[0].fileurl]);
      formik.setFieldValue("brandLogo", image[0].fileurl);
    }
    toggleImageModal();
    setSelectedImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImage = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      setUploadedImages([newImage]);
    }
  };


  // ---------- FORM VALIDATION ----------
  const formik = useFormik({
    initialValues: {
      title: "",
      category: "",
      published_date: "",
      status: "",
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please enter the title"),
      category: Yup.string().required("Please select category"),
      published_date: Yup.string().required("Please select date"),
      status: Yup.string().required("Please select status"),
      metaTitle: Yup.string().required("Meta title is required"),
      metaDescription: Yup.string()
        .required("Meta description is required")
        .max(180, "Max 180 characters allowed"),
      metaKeywords: Yup.string().required("Meta keywords are required"),
    }),

    // ---------- FORM SUBMISSION ----------
    onSubmit: async (values) => {
  try {
    const res = await fetch(`${baseurl}/admin/blogs/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: values.title,
        category: values.category,
        blog_img: uploadedImages ? uploadedImages[0] : "",  // string (url)
        cdate: values.published_date,
        blog_discription: shortContent,
        meta_title: values.metaTitle,
        meta_description: values.metaDescription,
        meta_keywords: values.metaKeywords,
        status: values.status,
      }),
    });

    const data = await res.json();
    console.log("Response:", data);

    if (data.success) {
      toast.success('Blog Added Successfully!', 'success');
      
      formik.resetForm();
      setUploadedImages(null);
      setShortContent("");
    }
  } catch (err) {
    console.error("Blog Submit Error:", err);
  }
},
  });

  // ---------- QUILL CONFIG ----------
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "align",
    "link",
    "image",
  ];

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Blog" breadcrumbItem="Add Blog" />

          
          {/* BLOG FORM CARD */}
          <Card>
            <CardBody>
              <Row>
                {/* TITLE */}
                <Col sm={6}>
                  <div className="mb-3">
                    <Label>Blog Title</Label>
                    <Input
                      name="title"
                      type="text"
                      placeholder="Enter Title"
                      onChange={(e) => {
                        formik.handleChange(e);
                       
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.title}
                      invalid={
                        formik.touched.title && Boolean(formik.errors.title)
                      }
                    />
                    <FormFeedback>{formik.errors.title}</FormFeedback>
                  </div>
                </Col>

                
                {/* CATEGORY */}
                <Col sm={6}>
                  <div className="mb-3">
                    <Label>Select Category</Label>
                    <Input
                      name="category"
                      type="select"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.category}
                      invalid={
                        formik.touched.category &&
                        Boolean(formik.errors.category)
                      }
                    >
                      <option value="">Select Category</option>
                      <option value="Life Style">Life Style</option>
                      <option value="Technology">Technology</option>
                      <option value="Business">Business</option>
                      <option value="Others">Others</option>
                      <option value="Entertainment">Entertainment</option>
                      <option value="Fashion">Fashion</option>
                    </Input>
                    <FormFeedback>{formik.errors.category}</FormFeedback>
                  </div>
                </Col>

                {/* DATE */}
                <Col sm={3}>
                  <div className="mb-3">
                    <Label>Date</Label>
                    <Input
                      name="published_date"
                      type="date"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.published_date}
                      invalid={
                        formik.touched.published_date &&
                        Boolean(formik.errors.published_date)
                      }
                    />
                    <FormFeedback>{formik.errors.published_date}</FormFeedback>
                  </div>
                </Col>

                {/* STATUS */}
                <Col sm={3}>
                  <div className="mb-3">
                    <Label>Status</Label>
                    <Input
                      name="status"
                      type="select"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.status}
                      invalid={
                        formik.touched.status &&
                        Boolean(formik.errors.status)
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Input>
                    <FormFeedback>{formik.errors.status}</FormFeedback>
                  </div>
                </Col>

                {/* IMAGE UPLOAD */}
                <Col sm={6}>
                  <div className="mb-3">
                    <Label>Blog Image</Label>

                    <div
                      className="custom-file-button"
                      onClick={toggleImageModal}
                    >
                      <i className="bx bx-cloud-upload me-2"></i>Choose Image
                    </div>

                    <Input
                      name="images"
                      type="file"
                      accept="image/*"
                      innerRef={imageInputRef}
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </Col>

                {uploadedImages && (
                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                          <div className="p-2">
                            <Row className="d-flex justify-content-between align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="100"
                                  width="100"
                                  className="avatar-md rounded bg-light"
                                  alt="images"
                                  src={imgurl + uploadedImages}
                                />
                              </Col>
                              <Col className="col-auto">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    setUploadedImages(null);
                                  }}
                                >
                                  Delete
                                </button>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      )}

                {/* BLOG DESCRIPTION */}
                <Col sm={12} className="mb-5">
                  <Label>Blog Description</Label>
                  <ReactQuill
                    value={shortContent}
                    onChange={handleShortContentChange}
                    modules={quillModules}
                    formats={quillFormats}
                    style={{ height: "250px" }}
                  />
                </Col>

                
              </Row>
            </CardBody>
          </Card>

          {/* META CARD */}
          <Card>
            <CardBody>
              <CardTitle>Meta Data</CardTitle>
              <Row>
                <Col sm={6}>
                  <div className="mb-3">
                    <Label className="form-label">Meta Title</Label>
                    <Input
                      name="metaTitle"
                      type="text"
                      placeholder="Meta Title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaTitle}
                      invalid={
                        formik.touched.metaTitle &&
                        Boolean(formik.errors.metaTitle)
                      }
                    />
                    <FormFeedback>{formik.errors.metaTitle}</FormFeedback>
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Meta Keywords</Label>
                    <Input
                      name="metaKeywords"
                      type="text"
                      placeholder="Keyword1, Keyword2"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaKeywords}
                      invalid={
                        formik.touched.metaKeywords &&
                        Boolean(formik.errors.metaKeywords)
                      }
                    />
                    <FormFeedback>{formik.errors.metaKeywords}</FormFeedback>
                  </div>
                </Col>

                <Col sm={6}>
                  <Label className="form-label">Meta Description</Label>
                  <textarea
                    name="metaDescription"
                    className="form-control"
                    rows="5"
                    maxLength="180"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.metaDescription}
                  ></textarea>
                  <small>
                    {formik.values.metaDescription.length}/180 characters
                  </small>
                  <div className="text-danger">
                    {formik.errors.metaDescription}
                  </div>
                </Col>
                {/* SUBMIT BUTTON */}
                <Col sm={12} className="text-end mt-4">
                  <Button color="success" onClick={formik.handleSubmit}>
                    Save Blog
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>


          {/* IMAGE SELECT MODAL */}
          <MediaModel
            imageModel={imageModel}
            toggleModal={toggleImageModal}
            handleUploadImage={handleUploadImage}
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
          />
        </Container>
      </div>
    </>
  );
};

export default AddBlog;
